const REPORT_KOR = {
  COVER_IMG_TITLE: '관상동맥 CT-FFR 분석결과',
  LAD: '좌전하행동맥',
  LCX: '좌회선동맥',
  RCA: '우관상동맥',
  WARNING:
    '이 보고서는 컴퓨터 시뮬레이션을 통해 귀하의 관상동맥 건강상태를 진단한 결과로, 참고용으로 제공됩니다. 정확한 진단과 치료를 위해 반드시 의료진과 상담하시기 바랍니다.',
};

const REPORT_ENG = {
  COVER_IMG_TITLE: 'Analysis of Coronary Artery CT-FFR',
  LAD: 'Left Anterior Descending artery, LAD',
  LCX: 'Left Circumflex artery, LCX',
  RCA: 'Right Coronary Artery, RCA',
  WARNING:
    'FFRCT is > 0.80 distal to all modeled stenoses. FFRCT is ≤ 0.80 at the end of the modeled vessel(s)',
};

export const REPORT = {
  KOR: REPORT_KOR,
  ENG: REPORT_ENG,
};

type CtFFRResultSection = {
  TITLE: string;
  DESCRIPTION: string[];
  COLOR_GUIDE: string[];
  TABLE: {
    TITLE: string;
    HEADER: {
      VESSEL: string;
      VALUE: string;
      COMMENT: string;
    };
    VESSELS: {
      LAD: string;
      RCA: string;
      LCX: string;
    };
    COMMENT: {
      LOW: string;
      BORDERLINE: string;
      NORMAL: string;
    };
  };
  FOOTNOTE: string[];
};

const HEALTH_CHECKUP_REPORT_KOR = {
  PATIENT: {
    ID: '등록번호',
    MALE: '남성',
    FEMALE: '여성',
    AGE: '세',
    SUFFIX: '님',
  },
  SCAN_DATE: '촬영일자',
  DATE_FORMAT: 'YYYY.MM.DD',
  REPORT_TITLE: '관상동맥 건강 검진 보고서',
  SECTIONS: {
    WHAT_IS_CORONARY: {
      TITLE: '관상동맥이란?',
      DESC: `관상동맥은 심장 근육에 혈액과 산소를 공급하는 중요한 혈관입니다.
관상동맥은 주로 좌전하행동맥(LAD), 좌회선동맥(LCX), 우관상동맥(RCA)의 세 가지 주요 혈관으로 나뉩니다.
이러한 혈관들의 건강 상태는 심장 건강과 직결되어 있어, 정기적인 관찰과 관리가 심혈관 건강에 도움이 될 수 있습니다.`,
    },
    WHAT_IS_FFR: {
      TITLE: 'FFR(분획혈류예비력)이란?',
      DESC: `FFR은 관상동맥의 혈류 흐름을 평가하는 유용한 지표 중 하나입니다.
0.0에서 1.0 사이의 수치로 표현되며, 일반적으로 1.0에 가까울수록 혈류가 원활한 것으로 볼 수 있습니다.
통상적으로 FFR 수치가 0.8 이하인 경우 추가적인 검사나 치료가 필요할 수 있다고 여겨지지만, 이는 개인의 전반적인 건강 상태와 증상으로 판단되어야 합니다.`,
    },
    WHAT_IS_CTFFR: {
      TITLE: 'CT-FFR이란?',
      DESC: `CT-FFR은 심장 CT 영상을 활용하여 관상동맥의 혈류 상태를 컴퓨터로 계산하는 첨단 검사법입니다.
이 검사는 별도의 침습적 시술 없이도 혈류 평가가 가능하여 전자장비들에게 부담이 적으며,
이를 통해 심혈관 질환의 조기 발견과 예방적 건강관리에 도움이 될 수 있습니다.`,
    },
  },
  CTFFR_RESULT: {
    TITLE: '관상동맥 CT-FFR 분석결과',
    DESCRIPTION: [
      '검진자님의 관상동맥을 여러 각도에서 보여주는 CT-FFR 분석 결과입니다.',
      'CT-FFR 결과 이미지에서 혈관의 색상은 혈류 상태를 시각적으로 표현한 것입니다.',
    ],
    COLOR_GUIDE: [
      '밝은 색(흰색/노란색): 혈류가 비교적 원활한 상태를 나타냅니다.',
      '어두운 색(빨간색/검은색): 관심을 가지고 관찰이 필요한 부위를 나타냅니다.',
    ],
    TABLE: {
      TITLE: '검진자님의 CT-FFR 수치는 다음과 같습니다.',
      HEADER: {
        VESSEL: '혈관',
        VALUE: 'CT-FFR 수치',
        COMMENT: '소견',
      },
      VESSELS: {
        LAD: '좌전하행동맥(LAD)',
        RCA: '우관상동맥(RCA)',
        LCX: '좌회선동맥(LCX)',
      },
      COMMENT: {
        LOW: '정상 범위보다 낮은 수치를 보이고 있어 주의가 필요합니다. 전문의와 상담하시어 정밀 검사 및 적절한 치료 방안에 대해 논의하시기 바랍니다.',
        BORDERLINE:
          '경계선상의 수치를 보이고 있습니다. 생활습관 개선과 함께 정기적인 추적 관찰이 도움이 될 것으로 보입니다.',
        NORMAL: '비교적 양호한 상태를 유지하고 있는 것으로 판단됩니다.',
      },
    },
    FOOTNOTE: [
      '본 검사결과는 컴퓨터 시뮬레이션을 통한 분석으로서 의료진의 종합적인 판단을 돕기 위한 참고 자료입니다.',
      'CT-FFR 수치는 여러 요인에 의해 영향을 받을 수 있기 때문에 단일 검사 결과만으로는 진단이 내려지지 않습니다.',
      '검사 결과에 대한 정확한 해석과 향후 관리 계획은 담당 의료진과의 충분한 상담을 통해 결정하시기 바랍니다.',
    ],
  },
};

const HEALTH_CHECKUP_REPORT_EN = {
  PATIENT: {
    ID: 'Registration Number',
    MALE: 'Male',
    FEMALE: 'Female',
    AGE: 'yrs',
  },
  SCAN_DATE: 'Scan Date',
  DATE_FORMAT: 'MM.DD.YYYY',
  REPORT_TITLE: 'Coronary Artery Health Checkup Report',
  SECTIONS: {
    WHAT_IS_CORONARY: {
      TITLE: 'What is the Coronary Artery?',
      DESC: `The coronary arteries are vital blood vessels that supply blood and oxygen to the heart muscle. They are primarily divided into three main branches: the Left Anterior Descending (LAD) coronary artery, Left Circumflex (LCX) coronary artery, and the Right Coronary Artery (RCA).
The condition of these arteries is directly linked to overall heart health, and regular monitoring and management can contribute significantly to maintaining cardiovascular wellness.`,
    },
    WHAT_IS_FFR: {
      TITLE: 'What is FFR (Fractional Flow Reserve)?',
      DESC: `FFR, or Fractional Flow Reserve, is a useful indicator for assessing blood flow in the coronary arteries. It is expressed as a value between 0.0 and 1.0, with values closer to 1.0 generally indicating better blood flow.
      An FFR value of 0.8 or lower is typically considered a threshold that may warrant further evaluation; however, this should be interpreted in the context of the patient’s overall health and clinical condition.`,
    },
    WHAT_IS_CTFFR: {
      TITLE: 'What is CT-FFR?',
      DESC: `CT-FFR (Computed Tomography–Fractional Flow Reserve) is an advanced diagnostic technique that uses cardiac CT images to computationally assess blood flow in the coronary arteries. This non-invasive method allows for the evaluation of coronary blood flow without the need for an invasive procedure, making it less burdensome for patients. It can aid in the early detection of cardiovascular disease and support proactive heart health management.`,
    },
  },
  CTFFR_RESULT: {
    TITLE: 'Coronary CT-FFR Analysis Results',
    DESCRIPTION: [
      'These CT-FFR analysis results provide a multi-angled visualization of your coronary arteries.',
      'In the CT-FFR images, the color of the vessels visually represents the state of blood flow:',
    ],
    COLOR_GUIDE: [
      'Bright colors (white/yellow) indicate relatively smooth and unobstructed blood flow.',
      'Dark colors (red/black) highlight areas that may require further attention and monitoring.',
    ],
    TABLE: {
      TITLE: 'The CT-FFR measurements for your examination are as follows:',
      HEADER: {
        VESSEL: 'Blood vessel',
        VALUE: 'CT-FFR Value',
        COMMENT: 'Findings',
      },
      VESSELS: {
        LAD: 'Left Anterior Descending (LAD) coronary artery',
        RCA: 'Right Coronary Artery (RCA)',
        LCX: 'Left Circumflex (LCX) coronary artery',
      },
      COMMENT: {
        LOW: 'The value is below the normal range and warrants attention. We recommend consulting a specialist to discuss further diagnostic evaluation and appropriate treatment options.',
        BORDERLINE:
          'The result falls within a borderline range. Lifestyle modifications along with regular follow-up evaluations are recommended to support cardiovascular health.',
        NORMAL:
          'Findings indicate a relatively favorable and stable condition.',
      },
    },
    FOOTNOTE: [
      'This test result is based on computer simulation analysis and is intended to serve as a reference to support clinical decision-making.',
      'CT-FFR values can be influenced by various factors and should not be used alone to make a definitive diagnosis.',
      'For accurate interpretation of the results and to establish an appropriate follow-up plan, please consult with your healthcare provider.',
    ],
  },
};

const HEALTH_CHECKUP_REPORT_RU = {
  PATIENT: {
    ID: 'Регистрационный номер',
    MALE: 'мужчина',
    FEMALE: 'женщина',
    AGE: 'лет',
  },
  SCAN_DATE: 'Дата съёмки',
  DATE_FORMAT: 'DD.MM.YYYY',
  REPORT_TITLE: 'Отчёт о медицинском обследовании коронарных артерий',
  SECTIONS: {
    WHAT_IS_CORONARY: {
      TITLE: 'Что такое коронарные артерии?',
      DESC: `Коронарные артерии — это важные кровеносные сосуды, которые снабжают сердечную мышцу кровью и кислородом.
Коронарные артерии в основном делятся на три основных сосуда: передняя нисходящая артерия (LAD), огибающая артерия (LCX) и правая коронарная артерия (RCA).
Состояние этих сосудов напрямую связано со здоровьем сердца, поэтому регулярное наблюдение и уход могут способствовать поддержанию сердечно-сосудистого здоровья.`,
    },
    WHAT_IS_FFR: {
      TITLE: 'Что такое FFR (фракционный резерв кровотока)?',
      DESC: `FFR — один из полезных показателей для оценки кровотока в коронарных артериях.
Он выражается числом от 0,0 до 1,0, и обычно чем ближе значение к 1,0, тем свободнее кровоток.
Как правило, если значение FFR равно или ниже 0,8, может потребоваться дополнительное обследование, но это должно оцениваться комплексно с учётом общего состояния здоровья пациента.`,
    },
    WHAT_IS_CTFFR: {
      TITLE: 'Что такое CT-FFR?',
      DESC: `CT-FFR — это современный метод, который с помощью компьютерной томографии сердца рассчитывает состояние кровотока в коронарных артериях. Эта процедура неинвазивная, поэтому менее обременительна для обследуемого и помогает в раннем выявлении сердечно-сосудистых заболеваний и профилактическом контроле здоровья.`,
    },
  },
  CTFFR_RESULT: {
    TITLE: 'Результаты анализа коронарных артерий с помощью CT-FFR',
    DESCRIPTION: [
      'Это результат анализа CT-FFR, показывающий коронарные артерии обследуемого с разных ракурсов.',
      'Цвет сосудов на изображениях CT-FFR визуально отражает состояние кровотока.',
    ],
    COLOR_GUIDE: [
      'Светлые цвета (белый/жёлтый): означают относительно свободный кровоток.',
      'Тёмные цвета (красный/чёрный): указывают на участки, требующие пристального внимания и наблюдения.',
    ],
    TABLE: {
      TITLE: 'Значение CT-FFR обследуемого следующее.',
      HEADER: {
        VESSEL: 'Сосуд',
        VALUE: `Показатель
        CT-FFR`,
        COMMENT: 'Заключение',
      },
      VESSELS: {
        LAD: 'Передняя нисходящая артерия (LAD)',
        RCA: 'Правая коронарная артерия (RCA)',
        LCX: 'Огибающая артерия (LCX)',
      },
      COMMENT: {
        LOW: 'Значение ниже нормального диапазона, требуется обратить внимание. Рекомендуется проконсультироваться со специалистом для проведения более детального обследования и обсуждения соответствующего плана лечения.',
        BORDERLINE:
          'Показатель находится в пределах нормы. Коррекция образа жизни вместе с регулярным контролем состояния здоровья будет полезной.',
        NORMAL: 'Считается, что состояние относительно хорошее.',
      },
    },
    FOOTNOTE: [
      'результаты анализа получены методом компьютерного моделирования и служат справочным материалом для комплексной оценки медицинским персоналом.',
      'Показатели CT-FFR могут быть подвержены влиянию различных факторов, поэтому диагноз не ставится только на основе одного результата обследования.',
      'Точное толкование результатов обследования и план дальнейшего наблюдения следует определять после тщательной консультации с лечащим врачом.',
    ],
  },
};

// 중국어 간체
const HEALTH_CHECKUP_REPORT_CN = {
  PATIENT: {
    ID: '登记编号',
    MALE: '男',
    FEMALE: '女',
    AGE: '岁',
    PREFIX: '尊敬的',
  },
  SCAN_DATE: '拍摄日期',
  DATE_FORMAT: 'YYYY.MM.DD',
  REPORT_TITLE: '冠状动脉健康检查报告',
  SECTIONS: {
    WHAT_IS_CORONARY: {
      TITLE: '什么是冠状动脉？',
      DESC: `冠状动脉是向心肌供应血液与氧气的重要血管。
冠状动脉主要分为左前降支 (LAD)、左回旋支 (LCX) 以及右冠状动脉 (RCA) 这三条主要血管。
这些血管的健康状态与心脏健康直接相关，因此，定期的监测与管理有助于维持心血管健康。`,
    },
    WHAT_IS_FFR: {
      TITLE: '什么是 FFR（血流储备分数）？',
      DESC: `FFR 是评估冠状动脉血流的有用指标之一。
其表现为从 0.0~1.0 间的数值，一般越接近 1.0，血流越顺畅。
通常，当 FFR 值低于 0.8 时，可认为有必要进行进一步检查，但这应根据个人的整体健康状况判断。`,
    },
    WHAT_IS_CTFFR: {
      TITLE: '什么是 CT-FFR？',
      DESC: `CT-FFR 是采用心脏 CT 影像，通过计算机计算冠状动脉血流状态的先进检查方法。该检查无需单独的侵入性手术也可评估血流，这减轻了受检者的负担，并有助于心血管疾病的早期发现与预防性健康管理。`,
    },
  },
  CTFFR_RESULT: {
    TITLE: '冠状动脉 CT-FFR 分析结果',
    DESCRIPTION: [
      '下图为从多角度显示受检者冠状动脉的 CT-FFR 分析结果。',
      'CT-FFR 结果图像中，血管的颜色是血流状态的直观表现。',
    ],
    COLOR_GUIDE: [
      '浅色（白色/黄色）：表示血流相对顺畅的状态。',
      '深色（红色/黑色）：表示需留意观察的区域。',
    ],
    TABLE: {
      TITLE: '受检者的 CT-FFR 数值如下：',
      HEADER: {
        VESSEL: '血管',
        VALUE: `CT-FFR 数值`,
        COMMENT: '所见',
      },
      VESSELS: {
        LAD: '左前降支 (LAD)',
        RCA: '右冠状动脉 (RCA)',
        LCX: '左回旋支 (LCX)',
      },
      COMMENT: {
        LOW: '	显示数值低于正常范围，需多加注意。请咨询专科医师，以讨论详细检查以及妥善的治疗方案。',
        BORDERLINE:
          '	显示数值正处于临界值。改善生活习惯的同时，采取定期的后续观察也有所助益。',
        NORMAL: '被判断为维持相对较好的状态。',
      },
    },
    FOOTNOTE: [
      '本检查是通过计算机模拟分析得出的结果，旨在作为参考资料协助医疗团队做出综合判断。',
      '由于 CT-FFR 值会受到多种因素的影响，因此，不会根据单一的检查结果做出诊断。',
      '对与您检查结果的准确解析与未来的管理计划，请与您的医疗团队进行充分沟通后决定。',
    ],
  },
};

// 중국어 번체
const HEALTH_CHECKUP_REPORT_TW = {
  PATIENT: {
    ID: '登記編號',
    MALE: '男',
    FEMALE: '女',
    AGE: '歲',
  },
  SCAN_DATE: '拍摄日期',
  DATE_FORMAT: 'YYYY.MM.DD',
  REPORT_TITLE: '冠狀動脈健康檢查報告',
  SECTIONS: {
    WHAT_IS_CORONARY: {
      TITLE: '甚麼是冠狀動脈？',
      DESC: `冠狀動脈是為心臟肌肉提供血液和氧氣的重要血管。
冠狀動脈主要分為三條主要血管：左前降支動脈 (LAD)、左迴旋支動脈 (LCX) 和右冠狀動脈 (RCA)。
這些血管的健康與心臟健康有直接的關係，因此進行定期觀察和管理有助維持心血管健康。`,
    },
    WHAT_IS_FFR: {
      TITLE: '甚麼是 FFR（血流儲備分數）？',
      DESC: `FFR 是評估冠狀動脈血流狀況的有效指標之一。
它的數值介乎 0.0 到 1.0 之間，通常愈接近 1.0，血流越為順暢。
一般來說，當 FFR 數值為 0.8 或以下時，或需要進行其他檢查，但這需要結合個人整體健康狀況以作出綜合的判斷。`,
    },
    WHAT_IS_CTFFR: {
      TITLE: '甚麼是 CT-FFR？',
      DESC: `CT-FFR 是一種利用心臟 CT 影像，以電腦計算出冠狀動脈血流狀態的先進檢查方法。這項檢查在無需進行任何侵入性的施術方式即可評估血流狀況，減輕受檢人士的負擔，有助發現早期心血管疾病及進行預防性健康管理。`,
    },
  },
  CTFFR_RESULT: {
    TITLE: '冠狀動脈 CT-FFR 分析結果',
    DESCRIPTION: [
      '以下為以不同角度展示受檢者的冠狀動脈狀態的 CT-FFR 分析結果。',
      'CT-FFR 結果影像中的血管顏色顯示出血流狀態。',
    ],
    COLOR_GUIDE: [
      '淺色（白色/黃色）：代表血流相對暢順。',
      '深色（紅色/黑色）：代表需要仔細觀察的部分。',
    ],
    TABLE: {
      TITLE: '受檢者的 CT-FFR 數值如下：',
      HEADER: {
        VESSEL: '血管',
        VALUE: `CT-FFR 數值`,
        COMMENT: '所見',
      },
      VESSELS: {
        LAD: '左前降支 (LAD)',
        RCA: '右冠狀動脈 (RCA)',
        LCX: '左迴旋支 (LCX)',
      },
      COMMENT: {
        LOW: '顯示數值低於正常範圍，需多加注意。請諮詢專科醫師，討論詳細檢查及妥善的治療方案。',
        BORDERLINE:
          '顯示數值正處於臨界值。建議改善生活習慣，同時定期追蹤觀察有助於控制情況。',
        NORMAL: '該狀態判斷為相對良好。',
      },
    },
    FOOTNOTE: [
      '此檢測結果為電腦模擬分析結果，僅供醫護人員參考以作進行綜合判斷之用。',
      '因 CT-FFR 數值可受多種因素影響，因此無法僅以單一檢測結果作出診斷。',
      '請向負責的醫護人員諮詢，以獲得就檢測結果的準確解讀並決定後續治療方案。',
    ],
  },
};

// 일본어
const HEALTH_CHECKUP_REPORT_JA = {
  PATIENT: {
    ID: '登録番号',
    MALE: '男性',
    FEMALE: '女性',
    AGE: '歳',
    SUFFIX: '様',
  },
  SCAN_DATE: '撮影日',
  DATE_FORMAT: 'YYYY.MM.DD',
  REPORT_TITLE: '冠状動脈健康診断報告書',
  SECTIONS: {
    WHAT_IS_CORONARY: {
      TITLE: '冠状動脈とは？',
      DESC: `冠状動脈は、心臓の筋肉に血液と酸素を供給する、重要な血管です。
冠状動脈は、主に左前下行枝(LAD)、左回旋枝(LCX)、右冠動脈(RCA)の3つの主要血管に分かれています。
これらの血管の健康状態は、心臓の健康と直結しており、定期的な観察と管理が心血管の健康に役立ちます。`,
    },
    WHAT_IS_FFR: {
      TITLE: 'FFR(冠血流予備量比)とは？',
      DESC: `FFRは、冠状動脈の血液の流れを評価するのに役立つ指標の1つです。
0.0から1.0の数値で表され、一般的に、1.0に近いほど血流が円滑であると評価されます。
通常、FFR数値が0.8以下の場合は追加検査が必要だと考えられますが、個人の全般的な健康状態をふまえ、総合的に判断する必要があります。`,
    },
    WHAT_IS_CTFFR: {
      TITLE: 'CT-FFRとは？',
      DESC: `CT-FFRは、心臓のCT画像を活用し、冠状動脈の血流状態をコンピューターで計算する、先進的な検査方法です。この検査は、侵襲的な施術をすることなく血流を評価することができるため、受診者への負担が少なく、心血管疾患の早期発見、予防医療や健康管理に役立てることができます。`,
    },
  },
  CTFFR_RESULT: {
    TITLE: '冠状動脈CT-FFR分析結果',
    DESCRIPTION: [
      '受診者様の冠状動脈を、さまざまな角度から見ることができるCT-FFR分析結果です。',
      'CT-FFR結果イメージにおける血管の色は、血流状態を視覚的に表したものです。',
    ],
    COLOR_GUIDE: [
      '明るい色(白/黄)：血流が比較的円滑な状態であることを表します。',
      '暗い色(赤/黒)：注意深く観察が必要な部分であることを表します。',
    ],
    TABLE: {
      TITLE: '受診者様のCT-FFR数値は以下のとおりです。',
      HEADER: {
        VESSEL: '血管',
        VALUE: `CT-FFR数値`,
        COMMENT: '所見',
      },
      VESSELS: {
        LAD: '左前下行枝(LAD)',
        RCA: '右冠動脈(RCA)',
        LCX: '左回旋枝(LCX)',
      },
      COMMENT: {
        LOW: '正常範囲より低い数値を示しているため、注意が必要です。専門医と相談し、精密検査および適切な治療について話し合ってください。',
        BORDERLINE:
          'ボーダーラインに近い数値を示しています。生活習慣の改善とともに、定期的な経過観察が役に立つでしょう。',
        NORMAL: '比較的良好な状態を維持していると判断できます。',
      },
    },
    FOOTNOTE: [
      '本検査結果は、コンピューターシミュレーションを通した分析であり、医療スタッフによる総合的な判断をサポートするための参考資料です。',
      'CT-FFR数値は、さまざまな要因の影響を受けるため、単一の検査結果だけで診断が下りることはありません。',
      '検査結果についての正確な解釈や、今後の管理計画については、担当医と十分に相談の上、決定してください。',
    ],
  },
};

export const SUPPORTED_LANGUAGES = [
  'ko',
  'en',
  'ru',
  'zhCN',
  'zhTW',
  'ja',
] as const;

export type HealthCheckupReportLengType = (typeof SUPPORTED_LANGUAGES)[number];

type HealthCheckupSection = {
  TITLE: string;
  DESC: string;
};

type HealthCheckupReportContent = {
  PATIENT: {
    ID: string;
    MALE: string;
    FEMALE: string;
    AGE: string;
    PREFIX?: string;
    SUFFIX?: string;
  };
  SCAN_DATE: string;
  DATE_FORMAT: string;
  REPORT_TITLE: string;
  SECTIONS: {
    WHAT_IS_CORONARY: HealthCheckupSection;
    WHAT_IS_FFR: HealthCheckupSection;
    WHAT_IS_CTFFR: HealthCheckupSection;
  };
  CTFFR_RESULT: CtFFRResultSection;
};

export const HEALTH_CHECKUP_REPORT: Record<
  HealthCheckupReportLengType,
  HealthCheckupReportContent
> = {
  ko: HEALTH_CHECKUP_REPORT_KOR,
  en: HEALTH_CHECKUP_REPORT_EN,
  ru: HEALTH_CHECKUP_REPORT_RU,
  zhCN: HEALTH_CHECKUP_REPORT_CN,
  zhTW: HEALTH_CHECKUP_REPORT_TW,
  ja: HEALTH_CHECKUP_REPORT_JA,
};
